import { render, staticRenderFns } from "./BankRemitForm.vue?vue&type=template&id=5337904d&scoped=true"
import script from "./BankRemitForm.vue?vue&type=script&lang=js"
export * from "./BankRemitForm.vue?vue&type=script&lang=js"
import style0 from "./BankRemitForm.vue?vue&type=style&index=0&id=5337904d&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5337904d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/fe/mewo-website-vue-sea/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5337904d')) {
      api.createRecord('5337904d', component.options)
    } else {
      api.reload('5337904d', component.options)
    }
    module.hot.accept("./BankRemitForm.vue?vue&type=template&id=5337904d&scoped=true", function () {
      api.rerender('5337904d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/BankRemitForm.vue"
export default component.exports